/**
 * Listener middleware for handling schema validation failures
 * and dispatching user-friendly notifications
 */

import type { AppStartListening } from './store';

/**
 * Register schema failure listeners
 * This function should be called after the store is initialized to avoid circular dependencies
 */
export const registerSchemaFailureListeners = (
  _startAppListening: AppStartListening,
) => {
  // Listen for Hubs Resource Report query rejections (including schema failures)
  // startAppListening({
  //   matcher:
  //     hubsResourceReportApi.endpoints.getHubsResourceReport.matchRejected,
  //   effect: (action, listenerApi) => {
  //     // Check if it's a schema validation error
  //     const error = action.payload?.error as
  //       | string
  //       | { message?: string }
  //       | undefined;
  //     // Extract error message from various error formats
  //     const errorMessage =
  //       typeof error === 'string' ? error : error?.message || String(error);
  //     if (errorMessage.includes('SCHEMA_VALIDATION_ERROR')) {
  //       let message =
  //         'Failed to load Hubs Resource Report: Data validation error';
  //       if (errorMessage.includes('Invalid data format')) {
  //         message = 'Failed to load Hubs Resource Report: Invalid data format';
  //       } else if (errorMessage.includes('Unexpected error')) {
  //         message = 'Failed to load Hubs Resource Report: Unexpected error';
  //       }
  //       listenerApi.dispatch(
  //         notificationActions.showNotification({
  //           message,
  //           severity: 'error',
  //           autoHideDuration: 10000,
  //         }),
  //       );
  //     } else {
  //       console.error(action.payload);
  //       listenerApi.dispatch(
  //         notificationActions.showNotification({
  //           message:
  //             action.payload?.error ??
  //             'An error occurred while fetching Hubs Resource Report',
  //           severity: 'error',
  //           autoHideDuration: 10000,
  //         }),
  //       );
  //     }
  //   },
  // });
};
